module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard@3x-72b707085465d0d5f7d44562dfe7d6d8.png";